<template>
  <calm-page extra-class="cust" :title="$t('lmg.customer')">
    <template slot="actions">
      <calm-button variant="primary" icon="plus" @click="handleCreate()">
        {{ $t("new") }}
      </calm-button>
    </template>

    <!-- ═══════════════ SEARCH BAR ═══════════════ -->
    <calm-filter-bar :hide-actions="true">
      <calm-field :label="$t('search')">
        <input
          v-model="searchQuery"
          type="text"
          class="ed"
          :placeholder="$t('search')"
        />
      </calm-field>
    </calm-filter-bar>

    <!-- ═══════════════ TABLE (skin the existing el-table verbatim, §11) ═══════════════ -->
    <calm-table
      :total="total"
      :from="from"
      :to="to"
      :per-page.sync="pagination.perPage"
      :current-page.sync="pagination.currentPage"
      :per-page-options="pagination.perPageOptions"
      :per-page-label="$t('per_page') !== 'per_page' ? $t('per_page') : 'ต่อหน้า'"
      :count-label="$t('data')"
      :to-label="$t('to')"
      :of-label="$t('of')"
      :empty-title="$t('no_data') !== 'no_data' ? $t('no_data') : 'ไม่พบข้อมูล'"
    >
      <el-table
        :data="queriedData"
        row-key="id"
        header-row-class-name="thead-light"
        @sort-change="sortChange"
        @selection-change="selectionChange"
      >

        <el-table-column :label="$t('lmg.card_type')" min-width="100">
          <template slot-scope="{ row }">
            <div v-if="row.CardIDType == 1">{{ $t("lmg.card_type_1") }}</div>
            <div v-if="row.CardIDType == 2">{{ $t("lmg.card_type_2") }}</div>
            <div v-if="row.CardIDType == 3">{{ $t("lmg.card_type_3") }}</div>
          </template>
        </el-table-column>

        <el-table-column :label="$t('profile.cardid')" min-width="100">
          <template slot-scope="{ row }">
            {{ row.CardID }}
          </template>
        </el-table-column>

        <el-table-column :label="$t('profile.name')" min-width="120">
          <template slot-scope="{ row }">
            {{ row.FName }} {{ row.LName }}
          </template>
        </el-table-column>

         <el-table-column :label="$t('profile.gender')" min-width="120">
          <template slot-scope="{ row }">
            {{ row.GenderText }}
          </template>
        </el-table-column>

         <el-table-column :label="$t('profile.phone')" min-width="120">
          <template slot-scope="{ row }">
            {{ row.Tel }}
          </template>
        </el-table-column>

         <el-table-column :label="$t('profile.email')" min-width="120">
          <template slot-scope="{ row }">
            {{ row.Email }}
          </template>
        </el-table-column>


        <el-table-column
          min-width="200px"
          align="right"
          :label="$t('actions')"
        >
          <div slot-scope="{ $index, row }" class="cust__rowact">
            <calm-button
              variant="ghost"
              size="sm"
              icon-only
              @click="handleEdit($index, row)"
            >
              <i class="fas fa-pen"></i>
            </calm-button>
            <!-- <calm-button
              variant="danger"
              size="sm"
              icon-only
              @click="handleDelete($index, row)"
            >
              <i class="fas fa-trash"></i>
            </calm-button> -->
          </div>
        </el-table-column>
      </el-table>
    </calm-table>

    <!-- ═══════════════ ADD / EDIT MODAL ═══════════════ -->
    <calm-modal
      :show.sync="showAddModal"
      :title="$t('lmg.customer')"
      size="lg"
      :show-footer="false"
    >
      <form class="cust__form" @submit.prevent="saveEvent">

        <!-- ─────── 1. ข้อมูลบัตร (Card / national-ID) ─────── -->
        <calm-form-section :num="1" :title="$t('lmg.card_type')">
          <div class="calm__form-grid calm__form-grid--3">
            <calm-form-row :label="$t('lmg.card_type')" required>
              <base-input
                :name="$t('lmg.card_type')"
                rules="required"
                input-classes="form-control-alternative new-event--title"
              >
                <el-select
                  v-model="md.idCardType"
                  :placeholder="$t('lmg.card_type')"
                  popper-class="calm-pop"
                >
                  <el-option
                    v-for="option in idCardType"
                    :key="option.ID"
                    :label="option.Name"
                    :value="option.ID"
                  >
                  </el-option>
                </el-select>
              </base-input>
            </calm-form-row>

            <calm-form-row class="cust__col-span-2" :label="$t('lmg.cid')" required>
              <base-input
                v-model="md.idCardNumber"
                rules="required"
                :name="$t('lmg.cid')"
              ></base-input>
            </calm-form-row>
          </div>
        </calm-form-section>

        <!-- ─────── 2. ข้อมูลส่วนตัว (Person) ─────── -->
        <calm-form-section :num="2" :title="$t('profile.name')">
          <div class="calm__form-grid calm__form-grid--3">
            <calm-form-row :label="$t('profile.pname')" required>
              <base-input
                :name="$t('profile.pname')"
                rules="required"
                input-classes="form-control-alternative new-event--title"
              >
                <el-select
                  v-model="md.prefix"
                  :placeholder="$t('profile.pname')"
                  popper-class="calm-pop"
                >
                  <el-option
                    v-for="option in tablePname"
                    :key="option.ID"
                    :label="option.Name"
                    :value="option.ID"
                  >
                  </el-option>
                </el-select>
              </base-input>
            </calm-form-row>

            <calm-form-row class="cust__col-span-2" v-if="md.idCardType == 3" :label="$t('profile.fname')" required>
              <base-input
                :name="$t('profile.fname')"
                rules="required"
                v-model="md.FName"
              ></base-input>
            </calm-form-row>
            <calm-form-row v-if="md.idCardType != 3" :label="$t('profile.fname')" required>
              <base-input
                :name="$t('profile.fname')"
                rules="required"
                v-model="md.FName"
              ></base-input>
            </calm-form-row>
            <calm-form-row v-if="md.idCardType != 3" :label="$t('profile.lname')" required>
              <base-input
                :name="$t('profile.lname')"
                rules="required"
                v-model="md.LName"
              ></base-input>
            </calm-form-row>
          </div>

          <div class="calm__form-grid calm__form-grid--3 cust__mt">
            <calm-form-row :label="$t('lmg.tel')" required>
              <base-input
                :name="$t('lmg.tel')"
                rules="required"
                v-model="md.tel"
              ></base-input>
            </calm-form-row>

            <calm-form-row :label="$t('profile.gender')">
              <base-input
                :name="$t('profile.gender')"
                input-classes="form-control-alternative new-event--title"
              >
                <el-select
                  v-model="md.gender"
                  :placeholder="$t('profile.gender')"
                  popper-class="calm-pop"
                >
                  <el-option
                    v-for="option in gender"
                    :key="option.ID"
                    :label="option.Name"
                    :value="option.ID"
                  >
                  </el-option>
                </el-select>
              </base-input>
            </calm-form-row>

            <calm-form-row :label="$t('profile.birthday')">
              <base-input
                :name="$t('profile.birthday')"
              >
                <flat-picker
                  slot-scope="{ focus, blur }"
                  @on-open="focus"
                  @on-close="blur"
                  :config="{ allowInput: true }"
                  class="form-control datepicker"
                  v-model="md.dateOfBirth"
                >
                </flat-picker>
              </base-input>
            </calm-form-row>

            <calm-form-row class="cust__col-span-3" :label="$t('email')">
              <base-input
                :name="$t('email')"
                v-model="md.email"
              ></base-input>
            </calm-form-row>
          </div>
        </calm-form-section>

        <!-- ─────── 3. ที่อยู่ (Address cascade) ─────── -->
        <calm-form-section :num="3" :title="$t('lmg.address_customer')">
          <div class="calm__form-grid calm__form-grid--3">
            <calm-form-row class="cust__col-span-3" :label="$t('lmg.address_customer')" required>
              <base-input
                :name="$t('lmg.address_customer')"
                rules="required"
                v-model="md.address"
              ></base-input>
            </calm-form-row>

            <!-- Province -->
            <calm-form-row :label="$t('lmg.address_province')">
              <base-input
                :name="$t('lmg.address_province')"
                input-classes="form-control-alternative new-event--title"
              >
                <el-select
                  v-model="md.province_id"
                  :placeholder="$t('lmg.address_province')"
                  @change="handleProviceChange()"
                  filterable
                  popper-class="calm-pop"
                >
                  <el-option
                    v-for="option in ProvinceTable"
                    :key="option.code"
                    :label="option.name_th"
                    :value="option.code"
                  >
                  </el-option>
                </el-select>
              </base-input>
            </calm-form-row>

            <!-- District -->
            <calm-form-row v-if="md.province_id != 0 && md.province_id != ''" :label="$t('lmg.address_district')">
              <base-input
                :name="$t('lmg.address_district')"
                input-classes="form-control-alternative new-event--title"
              >
                <el-select
                  v-model="md.district_id"
                  :placeholder="$t('lmg.address_district')"
                  @change="handleDistrictChange()"
                  filterable
                  popper-class="calm-pop"
                >
                  <el-option
                    v-for="option in DistrictTable"
                    :key="option.code"
                    :label="option.name_th"
                    :value="option.code"
                  >
                  </el-option>
                </el-select>
              </base-input>
            </calm-form-row>

            <!-- Sub-district -->
            <calm-form-row v-if="md.district_id != 0 && md.district_id!= ''" :label="$t('lmg.address_subdistrict')">
              <base-input
                :name="$t('lmg.address_subdistrict')"
                input-classes="form-control-alternative new-event--title"
              >
                <el-select
                  v-model="md.sub_district_id"
                  :placeholder="$t('lmg.address_subdistrict')"
                  @change="handleSubDistrictChange()"
                  filterable
                  popper-class="calm-pop"
                >
                  <el-option
                    v-for="option in SubDistrictTable"
                    :key="option.code"
                    :label="option.name_th"
                    :value="option.code"
                  >
                  </el-option>
                </el-select>
              </base-input>
            </calm-form-row>

            <calm-form-row v-if="md.sub_district_id != 0 && md.sub_district_id!= ''" :label="$t('lmg.address_zipcode')" required>
              <base-input
                :name="$t('lmg.address_zipcode')"
                rules="required"
                v-model="md.postcode"
              ></base-input>
            </calm-form-row>
          </div>
        </calm-form-section>

        <input type="hidden" class="new-event--start" />
        <input type="hidden" class="new-event--end" />

        <div class="calm__modal__actions cust__actions">
          <calm-button variant="ghost" @click="showAddModal = false">
            {{ $t("close") }}
          </calm-button>
          <calm-button variant="primary" @click="handleUpdate()">
            {{ $t("save") }}
          </calm-button>
        </div>
      </form>
    </calm-modal>
  </calm-page>
</template>
<script>
import { Table, TableColumn, Select, Option } from "element-ui";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import { BasePagination } from "@/components";
import clientPaginationMixin from "./PaginatedTables/clientPaginationMixin";
import swal from "sweetalert2";
import { mapGetters, mapActions } from "vuex";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

export default {
  mixins: [clientPaginationMixin],
  components: {
    BasePagination,
    RouteBreadCrumb,
	flatPicker,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
  },
  computed: {
    ...mapGetters({
      tableDataOrg: "Customer/getDatas",
	  ProvinceTable:"Address/getProvince",
	  DistrictTable:"Address/getDistrict",
	  SubDistrictTable:"Address/getSubDistrict",
    }),
    tableData: function () {
      // console.log(this.$route.query.id);
      // if (this.$route.query.id != null) {
      //   return this.tableDataOrg.filter((m) => {
      //     return m.EnterpriseID == "" + this.$route.query.id;
      //   });
      // }

      return this.tableDataOrg;
    },
	tablePname(){
      if (this.md.idCardType == "") return this.pname
      return this.pname.filter(p=>{
        return p.Group == this.md.idCardType
      })
    },

  },
  data() {
    return {
      propsToSearch: ["FName", "LName","CardID","Tel"],
      selectedRows: [],
      showAddModal: false,
      md: {
        ID: "",
		idCardType:"",
		idCardNumber:"",
		FName:"",
		LName:"",
		prefix:"",
		gender:"",
		dateOfBirth:"",
		tel:"",
		email:"",
		address:"",
		province_id:"",
		district_id:"",
		sub_district_id:"",
		postcode:"",

      },
       activeStatus: [
        {
          ID: 1,
          Name: "ใช้งาน"
        },
        {
          ID: 0,
          Name: "ไม่ใช้งาน"
        }
      ],
	  idCardType: [
        { ID: 1, Name: this.$t("lmg.card_type_1") },
        { ID: 2, Name: this.$t("lmg.card_type_2") },
        { ID: 3, Name: this.$t("lmg.card_type_3") }
      ],
	  gender: [
        { ID: 1, Name: "ชาย" },
        { ID: 2, Name: "หญิง" },
        { ID: 3, Name: "ไม่ระบุ" }
      ],
      pname: [
        { ID: 0, Name: "ไม่ระบุ" ,Group: 1},
        { ID: 1, Name: "ด.ช." ,Group: 1},
        { ID: 2, Name: "ด.ญ." ,Group: 1},
        { ID: 3, Name: "นาย" ,Group: 1},
        { ID: 4, Name: "นางสาว" ,Group: 1},
        { ID: 5, Name: "นาง" ,Group: 1},
        { ID: 6, Name: "คุณ" ,Group: 1},
        { ID: 7, Name: "Miss" ,Group: 2},
        { ID: 8, Name: "MR" ,Group: 2},
        { ID: 9, Name: "MRS" ,Group: 2},
        { ID: 10, Name: "MS" ,Group: 2},
        { ID: 11, Name: "Master" ,Group: 2},
        { ID: 12, Name: "หจก." ,Group: 3},
        { ID: 13, Name: "บจก.",Group: 3 },
        { ID: 14, Name: "สำนัก",Group: 3 }
	  ]
    };
  },
  mounted() {
    this.listData();
  },
  methods: {
    ...mapActions({
      createData: "Customer/createData",
      updateData: "Customer/updateData",
      deleteData: "Customer/deleteData",
      listData: "Customer/listData",
	  listProvince: "Address/listProvince",
      listDistrict: "Address/listDistrict",
      listSubDistrict: "Address/listSubDistrict",
    }),
    // Trim a backend *core.Time string down to "YYYY-MM-DD" for v.Date().
    // Accepts: null, "", "YYYY-MM-DD", "YYYY-MM-DD HH:mm:ss", ISO 8601.
    // Returns "" for falsy / zero-time inputs so qs.stringify sends an
    // empty value and the BE skips the column instead of writing NULL.
    normalizeDateOfBirth(value) {
      if (!value) return "";
      const str = String(value);
      if (str.startsWith("0001-01-01")) return "";
      return str.slice(0, 10);
    },
    handleCreate() {
      this.showAddModal = true;
        this.md.ID= 0
        this.md.idCardType = ""
		this.md.idCardNumber = ""
		this.md.FName = ""
		this.md.LName = ""
		this.md.prefix = ""
		this.md.gender = ""
		this.md.dateOfBirth = ""
		this.md.tel = ""
		this.md.email = ""
		this.md.province_id = ""
		this.md.district_id = ""
		this.md.sub_district_id = ""
		this.md.postcode = ""
		this.md.address = ""
    },
    handleEdit(index, row) {
      this.showAddModal = true;

        this.md.ID= row.ID
		this.md.idCardType = row.CardIDType
		this.md.idCardNumber = row.CardID
		this.md.FName = row.FName
		this.md.LName = row.LName
		this.md.prefix = row.PrefixName
		this.md.gender = row.Gender
		// Normalise DateOfBirth so the PUT always sends a value the backend's
		// v.Date("dateOfBirth") parser can read (layout "2006-01-02").
		// The BE serialises *core.Time as "YYYY-MM-DD HH:mm:ss" (or null).
		// Without this, a user who only edits the address never re-touches the
		// flatpickr field, the raw "YYYY-MM-DD HH:mm:ss" string is submitted,
		// v.Date returns a zero time, and date_of_birth gets written as NULL.
		// Defense-in-depth: even if the DB column reverts to NOT NULL, this
		// form still works.
		this.md.dateOfBirth = this.normalizeDateOfBirth(row.DateOfBirth)
		this.md.tel = row.Tel
		this.md.email = row.Email
		this.md.province_id = row.ProvinceID == 0 ? "":row.ProvinceID
		this.md.district_id = row.DistrictID
		this.md.sub_district_id = row.SubDistrictID
		this.md.postcode = row.PostCode
		this.md.address = row.Address

		this.listDistrict({province_code : row.ProvinceID })
		this.listSubDistrict({district_code : row.DistrictID })
    },
    handleUpdate() {
      this.showAddModal = false;

      if (this.md.ID == 0) {
        // create
        this.createData(this.md)
          .then((resp) => {
            this.listData();
            swal.fire({
              title: this.$t("create_success"),
              text: ``,
              icon: "success",
              confirmButtonClass: "btn btn-success btn-fill",
              buttonsStyling: false,
            });
          })
          .catch((err) => {
            swal.fire({
              title: this.$t(err.response.data.Msg),
              text: this.getErrorText(err.response.data),
              icon: "error",
              confirmButtonClass: "btn btn-danger btn-fill",
              buttonsStyling: false,
            });
          });
      } else {
        // update

        this.updateData({id:this.md.ID,payload: this.md})
          .then((resp) => {
            this.listData();
            swal.fire({
              title: this.$t("edit_success"),
              text: ``,
              icon: "success",
              confirmButtonClass: "btn btn-success btn-fill",
              buttonsStyling: false,
            });
          })
          .catch((err) => {
            swal.fire({
              title: this.$t(err.response.data.Msg),
              text: this.getErrorText(err.response.data),
              icon: "error",
              confirmButtonClass: "btn btn-danger btn-fill",
              buttonsStyling: false,
            });
          });
      }
    },
    handleDelete(index, row) {
      swal
        .fire({
          title: this.$t("delete_confirm"),
          text: this.$t("delete_confirm_question") + row.Name,
          icon: "warning",
          showCancelButton: true,
          confirmButtonClass: "btn btn-success btn-fill",
          cancelButtonClass: "btn btn-danger btn-fill",
          confirmButtonText: this.$t("confirm"),
          cancelButtonText: this.$t("cancel"),
          buttonsStyling: false,
        })
        .then((result) => {
          if (result.value) {
            this.deleteData({
              id: row.ID,
            })
              .then((resp) => {
                this.listData();
                swal.fire({
                  title: this.$t("delete_success"),
                  text: ``,
                  icon: "success",
                  confirmButtonClass: "btn btn-success btn-fill",
                  buttonsStyling: false,
                });
              })
              .catch((err) => {
                swal.fire({
                  title: this.$t(err.response.data.Msg),
                  text: this.getErrorText(err.response.data),
                  icon: "error",
                  confirmButtonClass: "btn btn-danger btn-fill",
                  buttonsStyling: false,
                });
              });
          }
        });
    },
    selectionChange(selectedRows) {
      this.selectedRows = selectedRows;
    },
	handleProviceChange() {
		this.md.district_id = ''
		this.md.sub_district_id = ''
		this.listDistrict({province_code : this.md.province_id })
	},
	handleDistrictChange() {
		this.md.customerSubDistrictID = ''
		this.listSubDistrict({district_code : this.md.district_id })
	},
	handleSubDistrictChange() {
		let subdistrict = this.SubDistrictTable.filter((v)=>{
			return v.code == this.md.sub_district_id
		})

		if (subdistrict != null ){
			this.md.postcode =subdistrict[0].zip_code
		}

		
	}
  },
};
</script>
<style scoped>
/* Customer CRUD — Calm skin. Everything namespaced under .cust so nothing
   leaks to other pages. The el-table is kept verbatim (§11 "skin, don't
   rewrite") and re-styled only through deep selectors below; the create/edit
   form keeps its base-input/vee-validate wrappers and el-select bindings,
   re-laid-out via calm-form-section + calm-form-row. */

/* Row-action cell: keep the icon button(s) inline + right-aligned. */
.cust__rowact {
  display: inline-flex;
  gap: 6px;
  justify-content: flex-end;
}

/* The free-text search box reuses the Kit's .ed input look. */
.cust >>> .ed {
  width: 100%;
}

/* Grid spans for fields that should occupy more than one column in the
   3-column form grid (mirrors the legacy col-lg-8 / full-width fields). */
.cust__col-span-2 { grid-column: span 2; }
.cust__col-span-3 { grid-column: span 3; }
@media (max-width: 720px) {
  .cust__col-span-2,
  .cust__col-span-3 { grid-column: span 1; }
}

/* Spacing between the two field grids inside the personal-info section. */
.cust__mt { margin-top: 16px; }

/* Action row pinned to the bottom of the modal body. */
.cust__actions { margin-top: 20px; }

/* Drop the base-input's own bottom margin — calm-form-row owns the spacing. */
.cust__form >>> .form-group {
  margin-bottom: 0;
}
/* base-input renders its own <label>; we use calm-form-row's label instead,
   so hide the inner one to avoid a doubled label. */
.cust__form >>> .form-group > label {
  display: none;
}
/* Let the slotted el-select fill the row width. */
.cust__form >>> .el-select {
  width: 100%;
}

/* Skin the existing <el-table> so it reads as a Calm surface without
   touching any column definitions or slots (§11). Deep selectors only. */
.cust >>> .el-table {
  color: var(--c-text, #2c3e50);
  background: transparent;
}
.cust >>> .el-table th,
.cust >>> .el-table .thead-light th {
  background: var(--c-surface-soft, #f4f7fb);
  color: var(--c-text-soft, #5b6b7e);
  font-weight: 600;
  border-bottom: 1px solid var(--c-border, #e3e9f0);
}
.cust >>> .el-table td {
  border-bottom: 1px solid var(--c-border, #eef2f7);
}
.cust >>> .el-table::before {
  background: var(--c-border, #e3e9f0);
}
.cust >>> .el-table__row:hover > td {
  background: var(--c-surface-soft, #f7fafd) !important;
}
</style>
